import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { SalutationSubForm, Schema as SalutationSchema } from '../subforms/Salutation';
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { PeriodSubForm, Schema as PeriodSchema } from '../subforms/Period';
import { OtherInformationInformalSubForm,Schema as OtherInformationSchema } from '../subforms/OtherInformationInformal';
import { RecommendationSubForm, Schema as RecommendationSchema } from '../subforms/Recommendation';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';

export const ZimmerFerienjobberSchema = (settings) => (
    Yup.object()
        .concat(SalutationSchema)
        .concat(NameAndContactSchema(settings))
        .concat(PeriodSchema)
        .concat(OtherInformationSchema)
        .concat(RecommendationSchema(settings))
        .concat(DocumentsSchema(settings))
);

export const ZimmerFerienjobber = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={SalutationSubForm} colors={colors} settings={settings} />
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={PeriodSubForm} colors={colors} settings={settings} />
            <Field component={OtherInformationInformalSubForm} colors={colors} settings={settings} />
            <Field component={RecommendationSubForm} colors={colors} settings={settings} />
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
        </>
    );
}